<div class="container" *ngIf="!hideDefaultMessage">
    <p class="title">{{'label.PageDoesNotExist' | translate}}</p>
    <p class="paragraph">{{'text.PageDoesNotExistFirstParagraph' | translate}}</p>
    <p class="paragraph">{{'text.PageDoesNotExistSecondParagraph' | translate}}</p>
</div>